import { render, staticRenderFns } from "./PracticeSumupList.vue?vue&type=template&id=012531f2&"
import script from "./PracticeSumupList.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports